export default "/img/GI.ce6fe91b34c4b65a922c04bd4efa9e7d.png";